const t = [
  "conversational-ai/sidebar-visibility-changed"
];
function d() {
  return window.__bynderMicroFrontendCommunication ? window.__bynderMicroFrontendCommunication.persistedMessages || (window.__bynderMicroFrontendCommunication.persistedMessages = {}) : window.__bynderMicroFrontendCommunication = {
    handlers: {},
    persistedMessages: {}
  }, window.__bynderMicroFrontendCommunication;
}
function o() {
  return d().handlers;
}
function c() {
  return d().persistedMessages;
}
function a(s, e) {
  const n = o();
  if (n[s] || (n[s] = []), n[s].push(e), t.includes(s)) {
    const r = c()[s];
    r !== void 0 && e(r);
  }
  return e;
}
function u(s, e) {
  const n = o();
  if (!n[s])
    return;
  const i = n[s].indexOf(e);
  i !== -1 && n[s].splice(i, 1);
}
function f(...s) {
  const [e, n] = s, i = o();
  if (t.includes(e)) {
    const r = c();
    r[e] = n;
  }
  i[e] && i[e].forEach((r) => {
    r(n);
  });
}
export {
  f as publish,
  a as subscribe,
  u as unsubscribe
};
